class ExpandableContentLarge {
	constructor(elem) {
		this.elem = elem
		this.animationFrame;
		this.height = 0;
		this.duration = 300;


		if (this.isSupportingIO()) {
			this.observer = new IntersectionObserver((entry) => {
				if(entry[0].isIntersecting) {
					window.addEventListener('resize', () => this.onResize(this.elem))
				}
				else {
					window.removeEventListener('resize', () => this.onResize(this.elem))
				}
			})
	
			this.observer.observe(this.elem[0])
		} 

		this.elem.find('.expandable-content-large__title').click(() => {
			this.eventClick(this.elem)
		})
	}

	onResize(elem) {
		if (elem.hasClass('open')) {
			const content = $(elem.find('.expandable-content-large__content')[0])

			if(this.isSupportingIO()) {
				content.css({'maxHeight': this.getInnerHeight(content)})
			}
		}
	}

	isSupportingIO() {
		if ('IntersectionObserver' in window &&
			'IntersectionObserverEntry' in window &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

			if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
				return false
			}
			return true
		}
		return false
	}

	eventClick(elem) {
		const [content] = elem.find('.expandable-content-large__content');

		
		if(elem.hasClass('open')) {
			this.animateContent(content, 0, false, elem)
			
		} else {
			elem.addClass('open')
			this.height = content.offsetHeight !== 0 ? content.offsetHeight : this.height;
			content.style.height = 0;
			this.animateContent(content, this.height, true, elem)
		}
	}

	getInnerHeight(content) {
		let innerHeight = 0;
		
		content.children().toArray().forEach((child, i) => {
			const style = child.currentStyle || window.getComputedStyle(child);
			innerHeight += child.scrollHeight + this.parseStyle(style.marginTop, 10) + this.parseStyle(style.marginBottom, 10)
		})

		return innerHeight
	}

	parseStyle(style) {
		if(isNaN(parseInt(style, 10))) {
			return 0
		} else {
			return parseInt(style, 10)
		}
	}

	animateContent(element, targetHeight, open, parentElement) {
		let currentHeight = element.offsetHeight;
	
		const speed =
		  (open ? targetHeight : currentHeight) / (this.duration / 16.67);
	
	
		const step = () => {
		  if (currentHeight !== targetHeight) {
			currentHeight = open ? currentHeight + speed : currentHeight - speed;
	
			if (
			  (open && currentHeight + speed > targetHeight) ||
			  (!open && currentHeight - speed < targetHeight)
			) {
			  currentHeight = targetHeight;
			  !open && parentElement.removeClass("open");
			}
	
			element.style.height = currentHeight + "px";
			this.animationFrameOpen = requestAnimationFrame(step);
		  } else {
			cancelAnimationFrame(this.animationFrame);
			element.style.height = "auto";
		  }
		};
		this.animationFrame = requestAnimationFrame(step);
	  }
}

export default ExpandableContentLarge
